"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.isHoursAvailable = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _get2 = _interopRequireDefault(require("lodash/get"));

var _HoursOfOperationDaily = _interopRequireDefault(require("./HoursOfOperationDaily"));

var _HoursOfOperationWithPopup = _interopRequireDefault(require("./HoursOfOperationWithPopup"));

var _HoursOfOperationModal = _interopRequireDefault(require("./HoursOfOperationModal"));

var _HoursOfOperationLabeled = _interopRequireDefault(require("./HoursOfOperationLabeled"));

var _IconElement = _interopRequireDefault(require("../IconElement"));

var _utils = require("./utils");

require("./HoursOfOperation.css");

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var isHoursAvailable = function isHoursAvailable(hours) {
  return hours.filter(function (hour) {
    return (0, _utils.isTimeDefined)(hour.open) || (0, _utils.isTimeDefined)(hour.close);
  }).length > 0;
};

exports.isHoursAvailable = isHoursAvailable;

var HoursOfOperation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(HoursOfOperation, _React$Component);

  var _super = _createSuper(HoursOfOperation);

  function HoursOfOperation(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, HoursOfOperation);
    _this = _super.call(this, props);
    _this.createLabelForDays = _this.createLabelForDays.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(HoursOfOperation, [{
    key: "getLabeledComponentAndFirstDay",
    value: function getLabeledComponentAndFirstDay() {
      var _this$props = this.props,
          firstGroupLevel = _this$props.firstGroupLevel,
          hours = _this$props.hours,
          displayOption = _this$props.displayOption,
          startWithToday = _this$props.startWithToday,
          timezone = _this$props.timezone,
          orientation = _this$props.orientation,
          animated = _this$props.animated,
          celled = _this$props.celled,
          inlineHours = _this$props.inlineHours;
      var isHorizontal = orientation === 'horizontal';
      var data = null;
      var firstDay = null;

      if (firstGroupLevel === 'label') {
        data = (0, _utils.groupByLabel)(hours, this.createLabelForDays, displayOption, startWithToday, timezone);
        firstDay = (0, _get2["default"])(data, '[0][1][0]');
        firstDay.mainLabel = (0, _get2["default"])(data, '[0][0]');
      } else {
        data = (0, _utils.groupByDayLabel)(hours, this.createLabelForDays, displayOption, startWithToday, timezone);
        firstDay = (0, _get2["default"])(data, '[0][1][0]');
        firstDay.dayLabel = (0, _get2["default"])(data, '[0][0]');
      }

      var component = /*#__PURE__*/_react["default"].createElement(_HoursOfOperationLabeled["default"], {
        data: data,
        isHorizontal: isHorizontal,
        animated: animated,
        celled: celled,
        inlineHours: inlineHours
      });

      return [component, firstDay];
    }
  }, {
    key: "getDailyComponentAndFirstDay",
    value: function getDailyComponentAndFirstDay() {
      var _this$props2 = this.props,
          hours = _this$props2.hours,
          displayOption = _this$props2.displayOption,
          startWithToday = _this$props2.startWithToday,
          timezone = _this$props2.timezone,
          orientation = _this$props2.orientation,
          animated = _this$props2.animated,
          celled = _this$props2.celled,
          inlineHours = _this$props2.inlineHours;
      var isHorizontal = orientation === 'horizontal';
      var hourGroups = null;

      if (displayOption === 'grouped') {
        hourGroups = (0, _utils.groupByDayAndTime)(hours, this.createLabelForDays);
      } else {
        hourGroups = (0, _utils.groupByDay)(hours, this.createLabelForDays);
      }

      var startTodayHourGroups = (0, _utils.setTodayFirstInArray)(hourGroups, timezone);
      hourGroups = startWithToday ? startTodayHourGroups : hourGroups;

      var component = /*#__PURE__*/_react["default"].createElement(_HoursOfOperationDaily["default"], {
        hourGroups: hourGroups,
        isHorizontal: isHorizontal,
        animated: animated,
        celled: celled,
        inlineHours: inlineHours
      });

      var firstDay = startTodayHourGroups[0];
      return [component, firstDay];
    }
  }, {
    key: "getPopUpLabelForLabeled",
    value: function getPopUpLabelForLabeled(hourDay) {
      var firstGroupLevel = this.props.firstGroupLevel;
      var label = '';
      var secondaryLabel = '';

      if (firstGroupLevel === 'day') {
        var _HoursOfOperation$get = HoursOfOperation.getPopUpLabelForDaily(hourDay);

        var _HoursOfOperation$get2 = (0, _slicedToArray2["default"])(_HoursOfOperation$get, 2);

        label = _HoursOfOperation$get2[0];
        secondaryLabel = _HoursOfOperation$get2[1];
      }

      if (firstGroupLevel === 'label') {
        label = hourDay.mainLabel === _utils.NO_LABEL ? 'See hours' : hourDay.mainLabel;
        secondaryLabel = hourDay.hoursValue.join(' | ');
      }

      return [label, secondaryLabel];
    }
  }, {
    key: "formatLabel",
    value: function formatLabel(label) {
      var _this$props3 = this.props,
          capitalizeLabels = _this$props3.capitalizeLabels,
          truncateLabels = _this$props3.truncateLabels;
      var displayedLabel = truncateLabels ? label.slice(0, 3) : label;
      return capitalizeLabels ? displayedLabel.toUpperCase() : displayedLabel;
    }
  }, {
    key: "createLabelForDays",
    value: function createLabelForDays(firstDay) {
      var secondDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var firstLabel = this.formatLabel(_utils.HOURS_LABELS[firstDay]);

      if (secondDay !== null) {
        var secondLabel = this.formatLabel(_utils.HOURS_LABELS[secondDay]);
        return "".concat(firstLabel, " - ").concat(secondLabel);
      }

      return firstLabel;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          className = _this$props4.className,
          showIcon = _this$props4.showIcon,
          displayOption = _this$props4.displayOption,
          iconAs = _this$props4.iconAs,
          hours = _this$props4.hours,
          timezone = _this$props4.timezone,
          displayOpenClosedStatus = _this$props4.displayOpenClosedStatus,
          header = _this$props4.header,
          subheader = _this$props4.subheader;

      if (!isHoursAvailable(hours)) {
        return null;
      }

      var hoursHaveLabels = hours.some(function (hour) {
        return !!(0, _utils.getHourLabel)(hour);
      });
      var mainComponent = null;
      var firstDay = null;
      var mainPopupLabel = null;
      var secondaryPopupLabel = null;

      if (hoursHaveLabels) {
        var _this$getLabeledCompo = this.getLabeledComponentAndFirstDay();

        var _this$getLabeledCompo2 = (0, _slicedToArray2["default"])(_this$getLabeledCompo, 2);

        mainComponent = _this$getLabeledCompo2[0];
        firstDay = _this$getLabeledCompo2[1];

        var _this$getPopUpLabelFo = this.getPopUpLabelForLabeled(firstDay);

        var _this$getPopUpLabelFo2 = (0, _slicedToArray2["default"])(_this$getPopUpLabelFo, 2);

        mainPopupLabel = _this$getPopUpLabelFo2[0];
        secondaryPopupLabel = _this$getPopUpLabelFo2[1];
      } else {
        var _this$getDailyCompone = this.getDailyComponentAndFirstDay();

        var _this$getDailyCompone2 = (0, _slicedToArray2["default"])(_this$getDailyCompone, 2);

        mainComponent = _this$getDailyCompone2[0];
        firstDay = _this$getDailyCompone2[1];

        var _HoursOfOperation$get3 = HoursOfOperation.getPopUpLabelForDaily(firstDay);

        var _HoursOfOperation$get4 = (0, _slicedToArray2["default"])(_HoursOfOperation$get3, 2);

        mainPopupLabel = _HoursOfOperation$get4[0];
        secondaryPopupLabel = _HoursOfOperation$get4[1];
      }

      if (displayOption === 'dailyWithPopup') {
        return /*#__PURE__*/_react["default"].createElement(_HoursOfOperationWithPopup["default"], {
          displayOpenClosedStatus: displayOpenClosedStatus,
          timezone: timezone,
          hours: firstDay.hours,
          label: mainPopupLabel,
          secondaryLabel: secondaryPopupLabel
        }, mainComponent);
      }

      var mainComponentWithHeaders = /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, header && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h2"
      }, header), subheader && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h3"
      }, subheader), mainComponent);

      if (displayOption === 'modal') {
        return /*#__PURE__*/_react["default"].createElement(_HoursOfOperationModal["default"], {
          iconAs: iconAs
        }, mainComponentWithHeaders);
      }

      return showIcon ? /*#__PURE__*/_react["default"].createElement(_IconElement["default"], {
        iconType: "clock",
        element: mainComponentWithHeaders,
        iconPosition: "top"
      }) : mainComponentWithHeaders;
    }
  }], [{
    key: "getPopUpLabelForDaily",
    value: function getPopUpLabelForDaily(hourDay) {
      var label = '';
      var secondaryLabel = '';

      if (!hourDay) {
        label = 'See hours';
      } else {
        label = hourDay.dayLabel;
        secondaryLabel = hourDay.hoursValue.join(' | ');
      }

      return [label, secondaryLabel];
    }
  }]);
  return HoursOfOperation;
}(_react["default"].Component);

exports["default"] = HoursOfOperation;
HoursOfOperation.propTypes = {
  hours: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    day: _propTypes["default"].number.isRequired,
    open: _propTypes["default"].number.isRequired,
    close: _propTypes["default"].number.isRequired,
    label: _propTypes["default"].string
  })).isRequired,
  animated: _propTypes["default"].bool,
  capitalizeLabels: _propTypes["default"].bool,
  celled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  displayOption: _propTypes["default"].oneOf(['daily', 'dailyWithPopup', 'grouped', 'modal']),
  displayOpenClosedStatus: _propTypes["default"].bool,
  startWithToday: _propTypes["default"].bool,
  header: _propTypes["default"].string,
  inlineHours: _propTypes["default"].bool,
  iconAs: _propTypes["default"].string,
  orientation: _propTypes["default"].oneOf(['horizontal', 'vertical']),
  showIcon: _propTypes["default"].bool,
  subheader: _propTypes["default"].string,
  timezone: _propTypes["default"].string,
  truncateLabels: _propTypes["default"].bool,
  firstGroupLevel: _propTypes["default"].oneOf(['label', 'day'])
};
HoursOfOperation.defaultProps = {
  animated: false,
  capitalizeLabels: false,
  celled: false,
  className: '',
  displayOption: 'daily',
  displayOpenClosedStatus: false,
  startWithToday: false,
  header: '',
  inlineHours: false,
  iconAs: 'icon',
  orientation: 'vertical',
  showIcon: false,
  subheader: '',
  timezone: null,
  truncateLabels: false,
  firstGroupLevel: 'day'
};
HoursOfOperation.propOptions = {
  header: ['Hours of Operation', 'Our Hours', '']
};
HoursOfOperation.dataPropsMap = {
  hours: ['business', 'primary_location', 'hours']
};